import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomProductSearchPage } from '@catalog/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS } from '@search/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

interface SearchProductQueryParams {
  query: string;
  fields: string;
  pageSize?: number;
  currentPage?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OccSearchService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    protected converter: ConverterService,
  ) {}

  loadSearchProduct(queryParams: SearchProductQueryParams): Observable<CustomProductSearchPage> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.productSearch, {
      queryParams: { ...queryParams },
    });

    return this.http.get<CustomProductSearchPage>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.productSearch),
    });
    // PRODUCT_SEARCH_PAGE_NORMALIZER нельзя прикручивать, так как если в ответе будут не все поля,
    // спартакусовский нормалайзер будет крашиться
    // .pipe(this.converter.pipeable<any, CustomProductSearchPage>(PRODUCT_SEARCH_PAGE_NORMALIZER));
  }
}
